/* Kaufraster der Aktionsseite: Mengenwahl, Intervallwahl, Direktkauf, Fortschritt.

   WARUM /cart/add.js UND NICHT EIN FORMULAR?
   Bei "3 fuer 2" legt derselbe Kunde mehrere Artikel nacheinander hinein. Ein
   normales Formular wuerde ihn nach jedem Klick auf die Warenkorbseite
   schicken. Mit fetch bleibt er auf der Seite, sieht am Button die
   Bestaetigung und unten, wie viel noch bis zum Gratisprodukt fehlt.

   MENGENWAHL: Wer drei Glaeser will, stellt die Menge auf 3 und klickt einmal.
   Die Menge geht als quantity mit; im Sparplan-Raster gibt es sie nicht.

   INTERVALLWAHL (Sparplan): Die Knoepfe tragen Plan-ID und den bereits von
   Liquid formatierten Preis. Ein Klick tauscht beides aus – es wird also nicht
   im Browser gerechnet und damit auch nicht falsch gerundet.

   FORTSCHRITT: Drei Segmente, eines je Artikel bis zum naechsten
   Gratisprodukt. Nach dem dritten faengt die Zaehlung von vorn an, weil die
   Rabattregel sich je vollem Dreierpaket wiederholt – dieselbe Logik wie in
   Shopify. Wer die Regel dort aendert, muss STUFE hier mitaendern.

   Die Zahl im Header wird mitgezogen: Nach jedem Hinzufuegen wird /cart.js
   gelesen und jedes Element mit einer der bekannten Warenkorb-Klassen des
   Themes aktualisiert. Faellt das aus, stimmt nur die Zahl oben nicht – der
   Warenkorb selbst ist trotzdem korrekt gefuellt. */
(function () {
  var STUFE = 3;
  var MAX = 12;

  function setzeKopfzahl(n) {
    var sel = '[data-header-cart-count], [data-cart-count], .cart-count, .header__cart-count, .cart-link__count';
    var els = document.querySelectorAll(sel);
    for (var i = 0; i < els.length; i++) els[i].textContent = n;
  }

  function hinweis(n) {
    var rest = (STUFE - (n % STUFE)) % STUFE;
    if (n === 0) return 'Noch ' + STUFE + ' Artikel bis zum Gratisprodukt';
    if (rest === 0) return '🎁 Geschafft – Dein günstigstes Produkt ist geschenkt';
    if (rest === 1) return 'Nur noch 1 Artikel – dann ist das günstigste geschenkt';
    return 'Noch ' + rest + ' Artikel bis zum Gratisprodukt';
  }

  function zeigeStand(bar, n) {
    if (!bar) return;
    var c = bar.querySelector('[data-lrg-count]');
    var h = bar.querySelector('[data-lrg-hint]');
    if (c) c.textContent = n;
    if (h) h.textContent = hinweis(n);

    var segs = bar.querySelectorAll('.lrg-prog__s');
    var voll = n > 0 && n % STUFE === 0;
    var an = voll ? STUFE : n % STUFE;
    for (var i = 0; i < segs.length; i++) segs[i].classList.toggle('is-on', i < an);
    bar.classList.toggle('lrg-bar--voll', voll);

    if (n > 0) { bar.removeAttribute('hidden'); } else { bar.setAttribute('hidden', ''); }
  }

  function ladeStand(bars) {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        setzeKopfzahl(c.item_count);
        for (var i = 0; i < bars.length; i++) zeigeStand(bars[i], c.item_count);
      })
      .catch(function () { /* Warenkorb bleibt wie er ist */ });
  }

  function alleBars() {
    return document.querySelectorAll('[data-lrg-bar]');
  }

  function initMenge(card) {
    var out = card.querySelector('[data-lrg-qty]');
    if (!out) return;
    var minus = card.querySelector('[data-lrg-minus]');
    var plus = card.querySelector('[data-lrg-plus]');

    function setze(n) {
      n = Math.max(1, Math.min(MAX, n));
      out.textContent = n;
      card.dataset.lrgMenge = n;
      if (minus) minus.disabled = n <= 1;
      if (plus) plus.disabled = n >= MAX;
    }
    if (minus) minus.addEventListener('click', function () { setze(parseInt(out.textContent, 10) - 1); });
    if (plus) plus.addEventListener('click', function () { setze(parseInt(out.textContent, 10) + 1); });
    setze(1);
  }

  /* Intervallwahl im Sparplan-Raster. Der Preis kommt fertig formatiert aus
     dem data-Attribut, damit hier nichts nachgerechnet wird. */
  function initIntervall(card) {
    var btns = card.querySelectorAll('[data-lrg-int]');
    if (!btns.length) return;
    var preis = card.querySelector('[data-lrg-price]');
    var add = card.querySelector('[data-lrg-add]');

    function waehle(gewaehlt) {
      for (var k = 0; k < btns.length; k++) {
        var an = btns[k] === gewaehlt;
        btns[k].classList.toggle('is-on', an);
        btns[k].setAttribute('aria-pressed', an ? 'true' : 'false');
      }
      if (preis && gewaehlt.dataset.price) preis.textContent = gewaehlt.dataset.price;
      if (add) add.dataset.plan = gewaehlt.dataset.plan;
    }

    for (var i = 0; i < btns.length; i++) {
      btns[i].addEventListener('click', function () { waehle(this); });
    }
  }

  function initAdd(card) {
    var add = card.querySelector('[data-lrg-add]');
    if (!add) return;
    var label = add.textContent;

    add.addEventListener('click', function () {
      if (add.disabled) return;
      add.disabled = true;

      var menge = parseInt(card.dataset.lrgMenge, 10) || 1;
      var body = { id: Number(add.dataset.variant), quantity: menge };
      if (add.dataset.plan) body.selling_plan = Number(add.dataset.plan);

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        add.classList.add('is-done');
        add.textContent = menge > 1 ? '✓ ' + menge + '× im Warenkorb' : '✓ Im Warenkorb';
        ladeStand(alleBars());
        setTimeout(function () {
          add.classList.remove('is-done');
          add.textContent = label;
          add.disabled = false;
        }, 1800);
      }).catch(function () {
        add.textContent = 'Bitte noch einmal';
        setTimeout(function () { add.textContent = label; add.disabled = false; }, 1800);
      });
    });
  }

  function boot() {
    var wraps = document.querySelectorAll('[data-lrg-root]');
    var neu = false;
    for (var w = 0; w < wraps.length; w++) {
      var root = wraps[w];
      if (root.dataset.lrgReady) continue;
      root.dataset.lrgReady = '1';
      neu = true;
      var cards = root.querySelectorAll('[data-lrg-card]');
      for (var i = 0; i < cards.length; i++) { initMenge(cards[i]); initIntervall(cards[i]); initAdd(cards[i]); }
    }
    if (neu) ladeStand(alleBars());
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
